export default __webpack_public_path__ + "static/media/speakers__may-li-khoe.4844fdbf.jpg";